var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 overflow-auto p-6",attrs:{"data-testid":"co-living-ticket-defaults-page"}},[_c('PageHeader',{attrs:{"title":_vm.$t('CO_LIVING.TICKETS.DEFAULTS.TITLE'),"icon":"ticket","allow-back":"","back-url":{
      name: 'co_living_tickets',
      params: { accountId: _vm.$route.params.accountId },
    }}}),_vm._v(" "),(_vm.loadError)?_c('p',{staticClass:"text-sm text-red-500",attrs:{"data-testid":"co-living-load-error"}},[_vm._v("\n    "+_vm._s(_vm.loadError)+"\n  ")]):_c('SettingsCard',{attrs:{"card-id":"tdef"}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }